<script>
  export default {
    props: {
      option: {
        type: Object,
        required: true,
      },
      active: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<template>
  <button type="button" class="typeUser__accountCard" :class="{ 'typeUser__accountCard--active': active }" @click="$emit('select', option.key)">
    <div class="typeUser__accountIcon" aria-hidden="true">
      <iconic :name="option.icon" />
    </div>

    <div class="typeUser__accountText">
      <span class="typeUser__accountName">{{ option.title }}</span>

      <small class="typeUser__accountDescription">{{ option.description }}</small>
    </div>
  </button>
</template>
<style lang="scss">
  .typeUser {
    &__accountName {
      transition: 0.3s ease-in-out;
      font-family: $newFont_medium;
      font-size: 18px;
      color: #3d3d3d;
    }

    &__accountDescription {
      font-size: 15px;
      font-family: $newFont_regular;
      transition: 0.3s ease-in-out;
      color: #949494;
    }

    &__accountCard {
      @include Flex(column, center, center);
      width: 100%;
      height: 160px;
      padding: $mpadding;
      background: #fafafa;
      border: 1px solid #f0f0f0;
      border-radius: 16px;
      text-align: center;
      cursor: pointer;
      position: relative;
      transition: 0.3s ease-in-out;
      font-size: 18px;

      &:hover {
        background: #fde9e9;
        .typeUser__accountIcon {
          color: $primary-color;
        }
        .typeUser__accountName {
          color: $primary-color;
        }
      }

      &--active {
        background: #fde9e9;
        border: 1px solid $primary-color;
        .typeUser__accountIcon {
          color: $primary-color;
        }
        .typeUser__accountName {
          color: $primary-color;
        }
      }
    }
  }
</style>
